var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.553,
    height: 16.886,
    viewBox: "0 0 17.553 16.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company_Name",
    "data-name": "Company Name",
    transform: "translate(-2.481 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2216349_building_building_location_commercial_company_map_icon",
    "data-name": "2216349_building_building location_commercial_company_map_icon",
    transform: "translate(-3.835 -3.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18045",
    "data-name": "Path 18045",
    d: "M16.728,6.063H6.317V22.949H16.728V6.063Zm-5.713,13.68H9.935V17.775h1.079Zm0-3.968H9.935V13.807h1.079Zm0-3.936H9.935V9.872h1.079Zm3.269,7.9H13.2V17.775h1.079Zm0-3.968H13.2V13.807h1.079Zm0-3.936H13.2V9.872h1.079Z",
    fill: "#8fa2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18046",
    "data-name": "Path 18046",
    d: "M23.869,20.822v-7.84H17.616v9.967h4.126A2.127,2.127,0,0,0,23.869,20.822Zm-2.412-1.047H19.362V18.727h2.095Zm0-2.635H19.362V16.061h2.095Z",
    fill: "#8fa2bb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyName);
export default __webpack_public_path__ + "static/media/Company Name.e45b835e3c0ee685ca509c1a91450e5f.svg";
export { ForwardRef as ReactComponent };